{
  "schemaVersion": "cogo.ux-pattern-definition.v1",
  "uxPatternId": "newsletter-operator-impact-controls",
  "version": "1.0.0",
  "target": "web",
  "intent": "Draft, preview, and apply a member content access change",
  "actorContext": "newsletter-operator",
  "requiredCapabilities": [
    "edit-operator-change-draft",
    "preview-content-impact",
    "apply-operator-change"
  ],
  "preconditions": ["member-focused"],
  "postconditions": ["change-applied"],
  "states": [
    { "stateId": "editing", "statusIntent": "idle" },
    { "stateId": "previewed", "statusIntent": "pending" },
    { "stateId": "applied", "statusIntent": "success" }
  ],
  "transitions": [
    {
      "transitionId": "edit",
      "fromState": "editing",
      "eventRef": "edit-change-draft",
      "toState": "editing",
      "effectRefs": ["persist-operator-change-draft"],
      "emitEventRefs": ["operator-change-draft-edited"]
    },
    {
      "transitionId": "preview",
      "fromState": "editing",
      "eventRef": "preview-impact",
      "toState": "previewed",
      "effectRefs": ["compute-change-impact"],
      "emitEventRefs": ["content-impact-previewed"]
    },
    {
      "transitionId": "apply",
      "fromState": "previewed",
      "eventRef": "apply-change",
      "toState": "applied",
      "effectRefs": ["merge-content-items"],
      "emitEventRefs": ["operator-change-applied"]
    }
  ],
  "ports": [
    { "portId": "edit-change-draft", "kind": "event", "direction": "in", "valueType": "cogo.operator-change-draft", "required": false },
    { "portId": "preview-impact", "kind": "event", "direction": "in", "valueType": "cogo.operator-change-draft", "required": false },
    { "portId": "apply-change", "kind": "event", "direction": "in", "valueType": "cogo.change-impact", "required": false },
    { "portId": "operator-change-draft-edited", "kind": "event", "direction": "out", "valueType": "cogo.operator-change-draft", "required": true },
    { "portId": "content-impact-previewed", "kind": "event", "direction": "out", "valueType": "cogo.change-impact", "required": true },
    { "portId": "operator-change-applied", "kind": "event", "direction": "out", "valueType": "cogo.change-impact", "required": true }
  ],
  "semanticNodes": [
    {
      "nodeId": "impact-draft",
      "semanticRole": "impact-draft",
      "regionRef": "capture",
      "content": { "label": "Change reason" },
      "visibleIn": ["editing", "previewed"]
    },
    {
      "nodeId": "preview-impact",
      "semanticRole": "secondary-action",
      "regionRef": "decision",
      "content": { "label": "Preview impact" },
      "visibleIn": ["editing"],
      "action": { "role": "secondary", "capabilityRef": "preview-content-impact", "slotRef": "decision-secondary" }
    },
    {
      "nodeId": "apply-change",
      "semanticRole": "primary-action",
      "regionRef": "decision",
      "content": { "label": "Apply change" },
      "visibleIn": ["previewed"],
      "action": { "role": "primary", "capabilityRef": "apply-operator-change", "slotRef": "decision-primary" }
    }
  ],
  "lineage": {
    "authorityStatus": "consumer-verified",
    "sourceKind": "human-authored-canonical",
    "sourceRefs": ["cogo:approved-source/newsletter-operator-impact-controls-v1"]
  }
}
